<div *transloco="let t">
  @if (toastMessage()) {
    <div class="error-message">
      <span>{{ t(toastMessage()) }}</span>
      <button class="close-btn" (click)="closeError()">x</button>
    </div>
  }
</div>
